import {endpoints} from '@kapitalist/contract/endpoints'
import type {TResponseOf} from '@kapitalist/contract/endpoints/types'
import {mkGameId} from '@kapitalist/contract/types'
import {PostApi} from '~/api/client'
import GetWaitingRoomData from '~/api/endpoints/game/PreGame/GetWaitingRoomData'

const endpoint = endpoints.pregame.createGame

type Response = TResponseOf<typeof endpoint>

/**
 * Create a new game that you can invite others to play in with you.
 */
export default class CreateGame extends PostApi<typeof endpoint>() {
  constructor() {
    super(endpoint)
  }

  protected getMockResponse(): Response {
    GetWaitingRoomData.resetMockPlayerCount()
    return {
      gameId: mkGameId('mock-new-game-id'),
    }
  }

  protected transformResponse(r: Response) {
    return r
  }
}
